The identifier for the job ad that was closed. This corresponds to the `PostedPositionProfile.profileId` field in the GraphQL schema, and may be supplied to the `positionProfile` query to retrieve the current state of the job ad.
